import { render, staticRenderFns } from "./DashboardRequests.vue?vue&type=template&id=a7edbb52&scoped=true"
import script from "./DashboardRequests.vue?vue&type=script&lang=js"
export * from "./DashboardRequests.vue?vue&type=script&lang=js"
import style0 from "./DashboardRequests.vue?vue&type=style&index=0&id=a7edbb52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7edbb52",
  null
  
)

export default component.exports